<template>
    <header class="p-3 navbar-custom">
        <div class="container-fluid">
            <div
                class="
                    d-flex
                    flex-wrap
                    align-items-center
                    justify-content-center justify-content-lg-start
                "
            >
                <ul
                    class="
                        nav
                        col-12 col-lg-auto
                        me-lg-auto
                        mb-2
                        justify-content-center
                        mb-md-0
                    "
                >
                </ul>
                <div class="dropdown text-end" v-if="auth != null">
                    <a
                        href="#"
                        class="
                            d-block
                            link-dark
                            text-decoration-none
                            dropdown-toggle
                        "
                        id="dropdownUser1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <div class="circular" v-if="$page.props.user.image">
                            <img class="profile-image" :src="'/' + $page.props.user.image" alt="">
                        </div>
                        <svg
                            v-else
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            fill="currentColor"
                            class="bi bi-person-circle"
                            viewBox="0 0 16 16"
                        >
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                            <path
                                fill-rule="evenodd"
                                d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                            />
                        </svg>
                    </a>
                    <ul
                        class="dropdown-menu text-small"
                        aria-labelledby="dropdownUser1"
                    >
                        <li><a class="dropdown-item" :href="'/users/' + $page.props.user.id">Profile</a></li>
                        <li><hr class="dropdown-divider" /></li>
                        <li>
                            <inertia-link
                                :href="route('logout')"
                                method="post"
                                as="button"
                                class="dropdown-item"
                                >Sign out</inertia-link
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters(["auth"]),
    },
};
</script>

<style>
.navbar-custom {
    left: 200px!important;
}
.circular {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.circular img {
  max-width: 55px;
  width: auto;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.dropdown-divider {
    margin: 0 !important;
}
</style>
